/* eslint-disable no-unused-vars */
const monthstonesData = [
  {
    title: 'Garnet',
    description:
      'Fierce and unapologetic, Garnet’s deep red hue symbolizes strength and passion. It helps those born in January stay focused and energized in pursuit of their goals, enhancing willpower and clearing away any mental blocks that may stand in the way.',
    bestfor: 'Motivation, Energy, Confidence',
    category: 'traditional',
    month: 'January',
  },
  {
    title: 'Amethyst',
    description:
      'Amethyst’s calming purple shades bring peace and serenity. It helps balance emotions, creating a sense of inner harmony and well-being—insomniacs of all ages can benefit from its gentle vibrations. It also awakens creativity, allowing problem-solving skills to blossom',
    bestfor: 'Calmness, Balance, Creativity',
    category: 'alternative',
    month: 'January',
  },
  {
    title: 'Emerald',
    description:
      'The Emerald is the stone of hope and renewal, activating your Heart chakra and granting you the courage to face your fears. It encourages action, igniting a flame of determination in those born under the sign of January—watch out world, here you come!',
    bestfor: 'Hope, Renewal, Courage',
    category: 'alternative',
    jevelry: '',
    link: 'https://consciousitems.com/blogs/lifestyle/january-birthstone',
    month: 'January',
  },
  {
    title: 'Amethyst',
    description:
      'The gentle purple of Amethyst radiates calm, providing a sense of equilibrium to those born in February. Releasing negative energy, Amethyst helps shift the focus to positive thoughts and emotions, making it easier to train the mind to recognize potential opportunities.',
    bestfor: 'Calmness, Balance, Security',
    category: 'traditional',
    month: 'February',
  },
  {
    title: 'Bloodstone',
    description:
      "Drive, ambition, and courage—that's the power of Bloodstone. It helps those born in February to stay on course, no matter how difficult the journey may get. It also encourages stability and provides a strong anchor against insecurities, doubts, and fears.",
    bestfor: 'Drive, Ambition, Courage',
    category: 'alternative',

    month: 'February',
  },
  {
    title: 'Aquamarine',
    description:
      'Aquamarine is the stone of clarity—keeping things in perspective and helping those born under the sign of February avoid becoming overwhelmed. It also boosts communication skills, giving them the courage to speak up and express themselves honestly.',
    bestfor: 'Patience, Communication, Clarity',
    category: 'alternative',
    jevelry: '',
    link: 'https://consciousitems.com/blogs/lifestyle/february-birthstone',
    month: 'February',
  },
  {
    title: 'Aquamarine',
    description:
      "The clarity and brilliance of Aquamarine help those born in March stay on their path, however winding the road may be. Go through life with poise and grace—Aquamarine will help you stay locked in on your life's mission, while still enjoying the journey.",
    bestfor: 'Traveling, Clarity, Openness',
    category: 'traditional',

    month: 'March',
  },
  {
    title: 'Bloodstone',
    description:
      'The power of Bloodstone is undeniable. A veritable wellspring of strength and determination, Bloodstone gives March-borns the nudge—or kick—to get up and make the most of every day. It also helps harness their ambition, guiding them toward success.',
    bestfor: 'Ambition, Strength, Determination',
    category: 'alternative',

    month: 'March',
  },
  {
    title: 'Amethyst',
    description:
      'Amethyst helps hone intuition and inspires creativity. It helps March-borns to stay in tune with the world around them, allowing them to harness positive energy without getting bogged down by negative influences.',
    bestfor: 'Intuition, Creativity, Positive Energy',
    category: 'alternative',

    month: 'March',
  },
  {
    title: 'Opal',
    description:
      'The shimmering waters of Opal help those born in March to stay grounded and in control of their emotions. It also encourages spiritual growth, helping them find peace within themselves. When life gets tough, Opal will help them stay strong.',
    bestfor: 'Emotional Control, Grounding, Spiritual Growth',
    category: 'alternative',
    jevelry: '',
    link: 'https://consciousitems.com/blogs/lifestyle/march-birthstone',
    month: 'March',
  },

  {
    title: 'Diamond',
    description:
      'Diamond is a symbol of love and commitment. As pure as can be, it helps those born under the sign of April to stay focused on what matters most to them by balancing your Crown chakra and providing a sense of peace and security.',
    bestfor: 'Love, Commitment, Balance',
    category: 'traditional',
    month: 'April',
  },
  {
    title: 'Sapphire',
    description:
      'Widely considered a chakra-clearing stone, Sapphire blasts away any negative energy and helps April-borns stay in tune with their inner power. Those stuck in creative ruts will also benefit from its energizing properties, inspiring new ideas and helping them tap into their full potential.',
    bestfor: 'Cleansing, Motivation, Creative Inspiration',
    category: 'alternative',
    jevelry: '',
    link: 'https://consciousitems.com/blogs/lifestyle/april-birthstone',
    month: 'April',
  },
  {
    title: 'Emerald',
    description:
      'When it comes to balancing your Heart chakra, nothing works better than Emerald. It helps May-borns to stay in touch with their deepest emotions, overcome fears and anxiety, and remain true to themselves.',
    bestfor: 'Emotional Connectivity, Self-Knowledge, Compassion',
    category: 'traditional',
    month: 'May',
  },
  {
    title: 'Agate',
    description:
      'A grounding stone par excellence, Agate helps you stay in control of any wayward emotions holding you back. Those born under the sign of May will find comfort in its protective energy, while also finding the motivation to strive toward success.',
    bestfor: 'Protection, Focus, Self-Motivation',
    category: 'alternative',
    jevelry: '',
    link: 'https://consciousitems.com/blogs/lifestyle/may-birthstone',
    month: 'May',
  },
  {
    title: 'Pearl',
    description:
      'Purity and innocence are the hallmarks of Pearl, a stone that helps those born in June stay true to themselves and their convictions. It also encourages harmony both within yourself and with the external world, allowing you to experience life’s joys without becoming overwhelmed by its complexities.',
    bestfor: 'Innocence, Harmony, Self-Awareness',
    category: 'traditional',

    month: 'June',
  },
  {
    title: 'Alexandrite',
    description:
      'Alexandrite helps to bring joy and light into the lives of June-borns. Its metaphysical properties help encourage self-love, and its ability to balance your emotions allows you to take on life’s challenges with a clear and positive mindset.',
    bestfor: 'Joy, Balance, Self-Love',
    category: 'alternative',

    month: 'June',
  },
  {
    title: 'Moonstone',
    description:
      'Tempering emotions and helping you stay in touch with your spiritual side, Moonstone is a powerful stone for those born under the sign of June. It encourages self-reflection and helps you see the bigger picture—opening your mind to new possibilities.',
    bestfor: 'Self-Reflection, Clarity, Spiritual Understanding',
    category: 'alternative',
    jevelry: '',
    link: 'https://consciousitems.com/blogs/lifestyle/june-birthstone',
    month: 'June',
  },
  {
    title: 'Ruby',
    description:
      'The hard-charging energy of Ruby helps July-borns stay driven and motivated to bring their goals to fruition. Ruby also helps stimulate creativity and protects against negative thoughts, allowing you to take calculated risks while still being rooted in a place of safety.',
    bestfor: 'Focus, Drive, Creative Stimulation',
    category: 'traditional',

    month: 'July',
  },
  {
    title: 'Carnelian',
    description:
      'Another stone of passion, Carnelian stokes the flames of creativity, ambition, and courage. Perfect for those transitioning from one stage of life to the next, it helps July-borns stay strong and steady in the face of change.',
    bestfor: 'Creative Expression, Ambition, Courage',
    category: 'alternative',
    jevelry: '',
    link: '',
    month: 'July',
  },
  {
    title: 'Peridot',
    description:
      'An excellent Heart chakra stone, Peridot helps August-borns to attract positive energy and stay open to new ideas. It also attracts prosperity and helps you recognize your blessings, preventing you from taking your good fortune for granted.',
    bestfor: 'Abundance, Positive Energy, Relationship Building',
    category: 'traditional',

    month: 'August',
  },
  {
    title: 'Sardonyx',
    description:
      'Uplifting and soothing, Sardonyx is a powerful stone that offers wisdom, courage, and protection. Its grounding properties help August-borns stay true to their convictions, while still remembering not to take life too seriously.',
    bestfor: 'Wisdom, Courage, Balance',
    category: 'alternative',

    month: 'August',
  },
  {
    title: 'Spinel',
    description:
      'Spinel acts like a roadmap for your soul, helping you stay on your true path and reach your highest potential. It is an excellent stone for August-borns, aiding in spiritual growth and inspiring creativity.',
    bestfor: 'Spiritual Growth, Creativity, Self-Realization',
    category: 'alternative',
    jevelry: '',
    link: '',
    month: 'August',
  },
  {
    title: 'Sapphire',
    description:
      'The lush blue hue of Sapphire encourages truth and faithfulness, while also calming deep emotions. Perfect for those born under the sign of September, its metaphysical properties help clarify and corral any nagging thoughts that prevent you from achieving your dreams.',
    bestfor: 'Vision, Wisdom, Insight',
    category: 'traditional',

    month: 'September',
  },
  {
    title: 'Lapis Lazuli',
    description:
      'An exfoliant for the soul, Lapis Lazuli helps to uncover the truth of who we are and what we want in life. It also encourages self-reflection and guides those born in September toward their highest purpose.',
    bestfor: 'Reflection, Self-Discovery, Harmony',
    category: 'alternative',
    jevelry: '',
    link: '',
    month: 'September',
  },
  {
    title: 'Tourmaline',
    description:
      "For October-borns who need a little reminder to stay grounded, Tourmaline is a must-have stone. It delivers protection and energy, freeing you to live life without fear or worry. Open up to Tourmaline's solid, stable vibrations and take on the world with full confidence!",
    bestfor: 'Protection, Grounding, Joy',
    category: 'traditional',
    month: 'October',
  },
  {
    title: 'Opal',
    description:
      'With its dreamy colors and mesmerizing flashes, Opal is a powerful stone that helps ease the flow of negative energies swirling around October-borns. It encourages inspiration and offers loving support, allowing you to step out of your comfort zone without forgetting who you are.',
    bestfor: 'Inspiration, Renewal, Self-Empowerment',
    category: 'alternative',

    month: 'October',
  },
  {
    title: 'Beryl',
    description:
      'Cleanse all that emotional baggage and let Beryl bring clarity and trust into your life. Scrubbing away all the nagging doubts and worries, this stone helps October-borns step into the light, imbuing them with the optimism and confidence needed to take on any challenge.',
    bestfor: 'Clarity, Strength, Trust',
    category: 'alternative',
    jevelry: '',
    link: '',
    month: 'October',
  },
  {
    title: 'Citrine',
    description:
      'The golden hue of Citrine is said to bring light and joy into the life of those born under November. It helps to clear away old beliefs, allowing you to embrace new ideas and put a positive spin on everything.',
    bestfor: 'Joy, Renewal, Manifestation',
    category: 'traditional',

    month: 'November',
  },
  {
    title: 'Topaz',
    description:
      "There's nothing like Topaz to carry you through times of uncertainty. This stone helps November-borns recognize the abundance around them and make use of it, allowing them to remain practical yet hopeful in the face of challenges.",
    bestfor: 'Abundance, Practicality, Hope',
    category: 'alternative',

    month: 'November',
  },
  {
    title: 'Chrysoprase',
    description:
      "Chrysoprase's lively teal hue hints at the expansive energies of this stone. It helps open up November-borns to new possibilities and encourages them to stay curious, allowing them to forgive their mistakes and start anew with a fresh perspective.",
    bestfor: 'Expansion, Forgiveness, Possibility',
    category: 'alternative',
    jevelry: '',
    link: '',
    month: 'November',
  },
  {
    title: 'Tanzanite',
    description:
      'The arresting blue shades of Tanzanite cradle the souls of those born in December. An excellent stone to facilitate journeys into the unknown, Tanzanite awakens the courage and strength needed to reveal new truths and embrace life to the fullest.',
    bestfor: 'Discovery, Spiritual Awakening, Purpose',
    category: 'traditional',

    month: 'December',
  },
  {
    title: 'Turquoise',
    description:
      'Banishing stagnant energy Turquoise is a stone of healing and growth for December-borns. It helps to clear the mind, allowing you to make sound decisions and heartfelt connections. Recharge and boost your spirit with the power of this stone!',
    bestfor: 'Revitalization, Positivity, Connection',
    category: 'alternative',

    month: 'December',
  },
  {
    title: 'Blue Topaz',
    description:
      "Let your inner wisdom take the wheel with Blue Topaz! This stone unearths the intuitive side of December-borns, soothing their worries and inspiring courage. Finally, it helps to recognize the signs of destiny and open up to possibilities far greater than what you could've imagined.",
    bestfor: 'Intuition, Wisdom, Self-Awareness',
    category: 'alternative',

    month: 'December',
  },
  {
    title: 'Blue Zircon',
    description:
      'Linked with all seven chakras, Blue Zircon can rinse away the impurities of life and start fresh. It helps December-borns discover their true passions and tap into a higher understanding of themselves, encouraging them to pursue greatness—in this world and beyond.',
    bestfor: 'Purification, Passion, Enlightenment',
    category: 'alternative',
    jevelry: '',
    link: '',
    month: 'December',
  },
];
